
var Graphics__prototype = Graphics.prototype;